<template>
  <CustomTag :modelosPermitidos="['Duimp']" :filtro="filtro" :path="path" />
</template>
<script>
import CustomTag from './CustomTag.vue';

export default {
  components: {
    CustomTag
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  }
}
</script>